import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './context/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { SnackbarProvider } from 'notistack';
import { Fade } from '@mui/material';
import ToolbarMixin from './ToolbarMixin';
import ErrorBoundaryWithNavigation from './ErrorBoundary';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <ErrorBoundaryWithNavigation>
    <Provider store={store}>
      <SnackbarProvider maxSnack={1} TransitionComponent={Fade} anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}>
        <ToolbarMixin />
        <App />
      </SnackbarProvider>
    </Provider>
  </ErrorBoundaryWithNavigation>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
